import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'cityads-v3/types/reducer';
import classes from './Menu.scss';

import MenuBottomLinks from './MenuBottomLinks';
import MenuContentGuest from './MenuContentGuest';
import MenuContentUser from './MenuContentUser';

export default function MenuContent(): JSX.Element {
  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn)
  return (
    <div className={classes.menuWrap}>
      <div className={classes.menuContent}>
        {isLoggedIn ? <MenuContentUser /> : <MenuContentGuest />}
      </div>
      <MenuBottomLinks />
    </div>
  )
}
